/* Allorn — Teddy buddy: swaps Teddy's (or Alex's) animation and tip as each section comes into view. */
(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const store = (k, v) => { try { if (v === undefined) return sessionStorage.getItem(k); sessionStorage.setItem(k, v); } catch (e) { return null; } };

  const initBuddy = (buddy) => {
    if (buddy.dataset.ready) return;
    buddy.dataset.ready = '1';
    let steps = [];
    try { steps = JSON.parse(buddy.querySelector('[data-buddy-steps]').textContent); } catch (e) { return; }
    steps = steps.filter((s) => document.querySelector(s.target));
    if (!steps.length) return;

    const [vidA, vidB] = buddy.querySelectorAll('.al-buddy__video');
    const bubble = buddy.querySelector('[data-buddy-bubble]');
    const nameEl = buddy.querySelector('[data-buddy-name]');
    const textEl = buddy.querySelector('[data-buddy-text]');
    const ctaEl = buddy.querySelector('[data-buddy-cta]');
    const toggle = buddy.querySelector('[data-buddy-toggle]');
    const close = buddy.querySelector('[data-buddy-close]');
    let front = vidA;
    let current = -1;
    const compact = window.matchMedia('(max-width: 1199px)');
    let pinned = false;
    let toastTimer;
    const toast = () => {
      if (!compact.matches || pinned || buddy.classList.contains('is-chatting')) return;
      setCollapsed(false, true);
      clearTimeout(toastTimer);
      toastTimer = setTimeout(() => { if (!pinned) setCollapsed(true, true); }, 4500);
    };

    const setCollapsed = (collapsed, auto) => {
      buddy.classList.toggle('is-collapsed', collapsed);
      if (!auto) store('alBuddyCollapsed', collapsed ? '1' : '0');
    };

    const show = (i) => {
      if (i === current) return;
      current = i;
      const step = steps[i];
      buddy.dispatchEvent(new CustomEvent('al:buddy-step', { detail: step }));
      // Crossfade the animation: load into the hidden layer, fade it in when it can play.
      const back = front === vidA ? vidB : vidA;
      back.poster = step.poster;
      if (reduce) {
        back.removeAttribute('src');
      } else if (back.getAttribute('src') !== step.video) {
        back.src = step.video;
      }
      const swap = () => {
        back.classList.add('is-on');
        front.classList.remove('is-on');
        front.pause();
        front = back;
      };
      if (reduce) swap();
      else back.play().then(swap).catch(swap);

      bubble.classList.add('is-swapping');
      setTimeout(() => {
        nameEl.textContent = step.name || 'Teddy';
        textEl.textContent = step.text || '';
        if (step.ctaLabel && step.ctaLink) {
          ctaEl.textContent = `${step.ctaLabel} →`;
          ctaEl.href = step.ctaLink;
          ctaEl.hidden = false;
        } else {
          ctaEl.hidden = true;
        }
        bubble.classList.remove('is-swapping');
        if (store('alBuddyCollapsed') !== '1' && !buddy.classList.contains('is-chatting')) {
          if (compact.matches) toast(); else setCollapsed(false, true);
        }
      }, reduce ? 0 : 220);
    };

    // Pick the step whose section sits nearest the middle of the viewport.
    let frame = 0;
    let lastY = window.scrollY;
    let leanTimer;
    const update = () => {
      frame = 0;
      const mid = window.innerHeight * 0.55;
      let best = 0;
      let bestDist = Infinity;
      steps.forEach((s, i) => {
        const el = document.querySelector(s.target);
        const r = el.getBoundingClientRect();
        const dist = r.top <= mid && r.bottom >= mid ? 0 : Math.min(Math.abs(r.top - mid), Math.abs(r.bottom - mid));
        if (dist < bestDist) { bestDist = dist; best = i; }
      });
      show(best);
      if (!reduce) {
        // Teddy leans into the scroll direction, then settles.
        const dy = window.scrollY - lastY;
        lastY = window.scrollY;
        const lean = Math.max(-8, Math.min(8, dy * 0.25));
        buddy.style.setProperty('--buddy-lean', `${lean}deg`);
        buddy.style.setProperty('--buddy-lift', `${-Math.min(10, Math.abs(dy) * 0.3)}px`);
        clearTimeout(leanTimer);
        leanTimer = setTimeout(() => { buddy.style.setProperty('--buddy-lean', '0deg'); buddy.style.setProperty('--buddy-lift', '0px'); }, 160);
      }
    };
    const queue = () => { if (!frame) frame = requestAnimationFrame(update); };

    // Tapping Teddy opens the chat (allorn-chat.js); the tip bubble tucks away while chatting.
    toggle.addEventListener('click', () => {
      pinned = false;
      clearTimeout(toastTimer);
      setCollapsed(true, true);
      buddy.dispatchEvent(new CustomEvent('al:chat-toggle'));
    });
    const chatLink = buddy.querySelector('[data-buddy-chat]');
    if (chatLink) chatLink.addEventListener('click', () => { clearTimeout(toastTimer); setCollapsed(true, true); buddy.dispatchEvent(new CustomEvent('al:chat-open')); });
    close.addEventListener('click', () => { pinned = false; clearTimeout(toastTimer); setCollapsed(true); toggle.focus(); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !buddy.classList.contains('is-collapsed') && !buddy.classList.contains('is-chatting')) setCollapsed(true); });
    ctaEl.addEventListener('click', (e) => {
      const href = ctaEl.getAttribute('href') || '';
      if (href.startsWith('#')) {
        const target = document.querySelector(href);
        if (target) { e.preventDefault(); target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' }); }
      }
    });

    // Pause the loop when the tab is hidden.
    document.addEventListener('visibilitychange', () => { if (document.hidden) front.pause(); else if (!reduce) front.play().catch(() => {}); });

    buddy.hidden = false;
    if (!reduce) buddy.classList.add('is-entering');
    setCollapsed(compact.matches || store('alBuddyCollapsed') === '1', true);
    window.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue);
    update();
  };

  /* ---------- Meet the duo: sound toggle for Alex ---------- */
  const initDuo = (duo) => {
    if (duo.dataset.ready) return;
    duo.dataset.ready = '1';
    const vids = [...duo.querySelectorAll('video')];
    const io = new IntersectionObserver((entries) => entries.forEach((e) => {
      const v = e.target;
      if (e.isIntersecting) { if (!v.src && v.dataset.src) v.src = v.dataset.src; if (!reduce) v.play().catch(() => {}); }
      else v.pause();
    }), { threshold: 0.4 });
    vids.forEach((v) => io.observe(v));
    duo.querySelectorAll('[data-duo-sound]').forEach((btn) => btn.addEventListener('click', () => {
      const v = btn.closest('.al-duo__media').querySelector('video');
      if (!v.src && v.dataset.src) v.src = v.dataset.src;
      const on = v.muted;
      v.muted = !on;
      btn.setAttribute('aria-pressed', String(on));
      btn.querySelector('span').textContent = on ? btn.dataset.off : btn.dataset.on;
      if (on) { v.currentTime = 0; v.play().catch(() => {}); }
    }));
  };

  const init = (root = document) => {
    root.querySelectorAll('[data-al-buddy]').forEach(initBuddy);
    root.querySelectorAll('[data-al-duo]').forEach(initDuo);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
